import { Helmet } from 'react-helmet';
import { NavLink } from 'react-router-dom';
import pageStyles from '../styles/page-common.module.css';


function About() {
  return (
    <>
      <Helmet>
        <title>About | LingoLeaf</title>
        <meta name="description" content="Discover LingoLeaf's innovative approach to language learning through engaging stories designed for learners at all levels." />
      </Helmet>
      <div className={pageStyles.styledPageLeftAligned}>
        <h1>About LingoLeaf</h1>
        <p>
          LingoLeaf is a web app you can use to help you learn a new language, focusing specifically on your reading skills.
          It provides fun, accessible short stories in your target language (see the <NavLink to='/languages'>list of languages</NavLink>), alongside annotations, translations, and comprehension questions.
        </p>
        <p>
          For more information about how LingoLeaf works and how to use it, see our <NavLink to='/faqs'>FAQs</NavLink>.
        </p>
        <p>
          LingoLeaf pledges 30% of its profits to <NavLink to='/charity'>tree-planting efforts</NavLink>.
        </p>
        <p>
          LingoLeaf is the work of a solo developer based in Edinburgh, Scotland, UK. He learns several languages in his spare time, including Japanese. The idea for LingoLeaf came after he noticed that it was very difficult to find fresh reading material at the right level for him to practice all the <a rel="noreferrer" target="_blank" href="https://en.wikipedia.org/wiki/Kanji">漢字</a> he was memorising!</p>
      </div>
    </>
  );
}


export default About;